import { __assign, __awaiter, __generator, __read } from "tslib";
import { GandalfLoginAssociationServiceException as __BaseException } from "../models/GandalfLoginAssociationServiceException";
import { AccessDeniedException, InternalServerException, InvalidGandalfTokenException, InvalidValidationTokenException, LoginAssociationException, MissingAttributeInGandalfTokenException, ThrottlingException, ValidationException, } from "../models/models_0";
import { HttpRequest as __HttpRequest, } from "@aws-sdk/protocol-http";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectNonNull as __expectNonNull, expectObject as __expectObject, expectString as __expectString, map as __map, throwDefaultError, } from "@aws-sdk/smithy-client";
export var serializeAws_restJson1BatchDeleteLoginAssociationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/batchDeleteLoginAssociation";
                body = JSON.stringify(__assign({}, (input.items != null && { "items": serializeAws_restJson1BatchDeleteLoginAssociationInputList(input.items, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1BatchFindLoginAssociationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/batchFindLoginAssociation";
                body = JSON.stringify(__assign({}, (input.items != null && { "items": serializeAws_restJson1BatchFindLoginAssociationInputList(input.items, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1BatchGetIdentityProviderExclusivityCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/batchGetIdentityProviderExclusivity";
                body = JSON.stringify(__assign({}, (input.items != null && { "items": serializeAws_restJson1BatchGetIdentityProviderExclusivityInputList(input.items, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1BatchGetLoginAssociationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/batchGetLoginAssociation";
                body = JSON.stringify(__assign({}, (input.items != null && { "items": serializeAws_restJson1BatchGetLoginAssociationInputList(input.items, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1BatchPutLoginAssociationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/batchPutLoginAssociation";
                body = JSON.stringify(__assign({}, (input.items != null && { "items": serializeAws_restJson1BatchPutLoginAssociationInputList(input.items, context) })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/putAccountLinkStatusWithTokenJustification";
                body = JSON.stringify(__assign(__assign({}, (input.gandalfToken != null && { "gandalfToken": input.gandalfToken })), (input.linkStatus != null && { "linkStatus": input.linkStatus })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCorsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = map({}, isSerializableHeaderValue, {
                    'origin': input.origin,
                });
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/putAccountLinkStatusWithTokenJustification";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "OPTIONS",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1PutAssociationWithTokenValidationCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = {
                    'content-type': 'application/json',
                };
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/putAssociationWithTokenValidation";
                body = JSON.stringify(__assign(__assign({}, (input.gandalfToken != null && { "gandalfToken": input.gandalfToken })), (input.gandalfValidationToken != null && { "gandalfValidationToken": input.gandalfValidationToken })));
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var serializeAws_restJson1PutAssociationWithTokenValidationCorsCommand = function (input, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                headers = map({}, isSerializableHeaderValue, {
                    'origin': input.origin,
                });
                resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith('/')) ? basePath.slice(0, -1) : (basePath || '')) + "/putAssociationWithTokenValidation";
                return [2, new __HttpRequest({
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "OPTIONS",
                        headers: headers,
                        path: resolvedPath,
                        body: body,
                    })];
        }
    });
}); };
export var deserializeAws_restJson1BatchDeleteLoginAssociationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1BatchDeleteLoginAssociationCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [(_b.apply(void 0, [_c.sent()])), "body"]);
                if (data.deleted != null) {
                    contents.deleted = deserializeAws_restJson1BatchDeleteLoginAssociationOutputList(data.deleted, context);
                }
                if (data.failed != null) {
                    contents.failed = deserializeAws_restJson1BatchDeleteLoginAssociationFailedOutputList(data.failed, context);
                }
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1BatchDeleteLoginAssociationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
export var deserializeAws_restJson1BatchFindLoginAssociationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1BatchFindLoginAssociationCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [(_b.apply(void 0, [_c.sent()])), "body"]);
                if (data.items != null) {
                    contents.items = deserializeAws_restJson1BatchFindLoginAssociationOutputMap(data.items, context);
                }
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1BatchFindLoginAssociationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
export var deserializeAws_restJson1BatchGetIdentityProviderExclusivityCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1BatchGetIdentityProviderExclusivityCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [(_b.apply(void 0, [_c.sent()])), "body"]);
                if (data.items != null) {
                    contents.items = deserializeAws_restJson1BatchGetIdentityProviderExclusivityOutputList(data.items, context);
                }
                if (data.notFound != null) {
                    contents.notFound = deserializeAws_restJson1BatchGetIdentityProviderExclusivityNotFoundOutputList(data.notFound, context);
                }
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1BatchGetIdentityProviderExclusivityCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
export var deserializeAws_restJson1BatchGetLoginAssociationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1BatchGetLoginAssociationCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [(_b.apply(void 0, [_c.sent()])), "body"]);
                if (data.failedItems != null) {
                    contents.failedItems = deserializeAws_restJson1BatchGetLoginAssociationFailedOutputList(data.failedItems, context);
                }
                if (data.items != null) {
                    contents.items = deserializeAws_restJson1BatchGetLoginAssociationOutputList(data.items, context);
                }
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1BatchGetLoginAssociationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
export var deserializeAws_restJson1BatchPutLoginAssociationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1BatchPutLoginAssociationCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [(_b.apply(void 0, [_c.sent()])), "body"]);
                if (data.associated != null) {
                    contents.associated = deserializeAws_restJson1BatchPutLoginAssociationOutputList(data.associated, context);
                }
                if (data.failed != null) {
                    contents.failed = deserializeAws_restJson1BatchPutLoginAssociationFailedOutputList(data.failed, context);
                }
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1BatchPutLoginAssociationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
export var deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "InvalidGandalfTokenException": return [3, 8];
                    case "training.aws.gandalf#InvalidGandalfTokenException": return [3, 8];
                    case "MissingAttributeInGandalfTokenException": return [3, 10];
                    case "training.aws.gandalf#MissingAttributeInGandalfTokenException": return [3, 10];
                    case "ThrottlingException": return [3, 12];
                    case "training.aws.gandalf#ThrottlingException": return [3, 12];
                }
                return [3, 14];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidGandalfTokenExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1MissingAttributeInGandalfTokenExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 15;
            case 15: return [2];
        }
    });
}); };
export var deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCorsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCorsCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1PutAccountLinkStatusWithTokenJustificationCorsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
export var deserializeAws_restJson1PutAssociationWithTokenValidationCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1PutAssociationWithTokenValidationCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                _a = __expectNonNull;
                _b = __expectObject;
                return [4, parseBody(output.body, context)];
            case 1:
                data = _a.apply(void 0, [(_b.apply(void 0, [_c.sent()])), "body"]);
                if (data.exclusivity != null) {
                    contents.exclusivity = __expectString(data.exclusivity);
                }
                if (data.hatId != null) {
                    contents.hatId = __expectString(data.hatId);
                }
                if (data.identityProvider != null) {
                    contents.identityProvider = __expectString(data.identityProvider);
                }
                if (data.loginId != null) {
                    contents.loginId = __expectString(data.loginId);
                }
                if (data.vibeId != null) {
                    contents.vibeId = __expectString(data.vibeId);
                }
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1PutAssociationWithTokenValidationCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "InvalidGandalfTokenException": return [3, 8];
                    case "training.aws.gandalf#InvalidGandalfTokenException": return [3, 8];
                    case "InvalidValidationTokenException": return [3, 10];
                    case "training.aws.gandalf#InvalidValidationTokenException": return [3, 10];
                    case "LoginAssociationException": return [3, 12];
                    case "training.aws.gandalf#LoginAssociationException": return [3, 12];
                    case "MissingAttributeInGandalfTokenException": return [3, 14];
                    case "training.aws.gandalf#MissingAttributeInGandalfTokenException": return [3, 14];
                    case "ThrottlingException": return [3, 16];
                    case "training.aws.gandalf#ThrottlingException": return [3, 16];
                }
                return [3, 18];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1InvalidGandalfTokenExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10: return [4, deserializeAws_restJson1InvalidValidationTokenExceptionResponse(parsedOutput, context)];
            case 11: throw _d.sent();
            case 12: return [4, deserializeAws_restJson1LoginAssociationExceptionResponse(parsedOutput, context)];
            case 13: throw _d.sent();
            case 14: return [4, deserializeAws_restJson1MissingAttributeInGandalfTokenExceptionResponse(parsedOutput, context)];
            case 15: throw _d.sent();
            case 16: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 17: throw _d.sent();
            case 18:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 19;
            case 19: return [2];
        }
    });
}); };
export var deserializeAws_restJson1PutAssociationWithTokenValidationCorsCommand = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode !== 200 && output.statusCode >= 300) {
                    return [2, deserializeAws_restJson1PutAssociationWithTokenValidationCorsCommandError(output, context)];
                }
                contents = map({
                    $metadata: deserializeMetadata(output),
                });
                return [4, collectBody(output.body, context)];
            case 1:
                _a.sent();
                return [2, contents];
        }
    });
}); };
var deserializeAws_restJson1PutAssociationWithTokenValidationCorsCommandError = function (output, context) { return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, errorCode, _b, parsedBody;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = [__assign({}, output)];
                _c = {};
                return [4, parseBody(output.body, context)];
            case 1:
                parsedOutput = __assign.apply(void 0, _a.concat([(_c.body = _d.sent(), _c)]));
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ValidationException": return [3, 2];
                    case "smithy.framework#ValidationException": return [3, 2];
                    case "AccessDeniedException": return [3, 4];
                    case "training.aws.gandalf#AccessDeniedException": return [3, 4];
                    case "InternalServerException": return [3, 6];
                    case "training.aws.gandalf#InternalServerException": return [3, 6];
                    case "ThrottlingException": return [3, 8];
                    case "training.aws.gandalf#ThrottlingException": return [3, 8];
                }
                return [3, 10];
            case 2: return [4, deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)];
            case 3: throw _d.sent();
            case 4: return [4, deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)];
            case 5: throw _d.sent();
            case 6: return [4, deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)];
            case 7: throw _d.sent();
            case 8: return [4, deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)];
            case 9: throw _d.sent();
            case 10:
                parsedBody = parsedOutput.body;
                throwDefaultError({
                    output: output,
                    parsedBody: parsedBody,
                    exceptionCtor: __BaseException,
                    errorCode: errorCode
                });
                _d.label = 11;
            case 11: return [2];
        }
    });
}); };
var map = __map;
var deserializeAws_restJson1ValidationExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.fieldList != null) {
            contents.fieldList = deserializeAws_restJson1ValidationExceptionFieldList(data.fieldList, context);
        }
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new ValidationException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1AccessDeniedExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new AccessDeniedException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InternalServerExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new InternalServerException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidGandalfTokenExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidGandalfTokenException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1InvalidValidationTokenExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new InvalidValidationTokenException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1LoginAssociationExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.loginAssociationErrorType != null) {
            contents.loginAssociationErrorType = __expectString(data.loginAssociationErrorType);
        }
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new LoginAssociationException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1MissingAttributeInGandalfTokenExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new MissingAttributeInGandalfTokenException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var deserializeAws_restJson1ThrottlingExceptionResponse = function (parsedOutput, context) { return __awaiter(void 0, void 0, void 0, function () {
    var contents, data, exception;
    return __generator(this, function (_a) {
        contents = map({});
        data = parsedOutput.body;
        if (data.message != null) {
            contents.message = __expectString(data.message);
        }
        exception = new ThrottlingException(__assign({ $metadata: deserializeMetadata(parsedOutput) }, contents));
        return [2, __decorateServiceException(exception, parsedOutput.body)];
    });
}); };
var serializeAws_restJson1BatchDeleteLoginAssociationInputList = function (input, context) {
    return input.filter(function (e) { return e != null; }).map(function (entry) {
        return serializeAws_restJson1BatchDeleteLoginAssociationInputListItem(entry, context);
    });
};
var serializeAws_restJson1BatchDeleteLoginAssociationInputListItem = function (input, context) {
    return __assign(__assign({}, (input.identityProvider != null && { "identityProvider": input.identityProvider })), (input.loginId != null && { "loginId": input.loginId }));
};
var serializeAws_restJson1BatchFindLoginAssociationInputList = function (input, context) {
    return input.filter(function (e) { return e != null; }).map(function (entry) {
        return serializeAws_restJson1BatchFindLoginAssociationInputListItem(entry, context);
    });
};
var serializeAws_restJson1BatchFindLoginAssociationInputListItem = function (input, context) {
    return __assign(__assign({}, (input.hatId != null && { "hatId": input.hatId })), (input.vibeId != null && { "vibeId": input.vibeId }));
};
var serializeAws_restJson1BatchGetIdentityProviderExclusivityInputList = function (input, context) {
    return input.filter(function (e) { return e != null; }).map(function (entry) {
        return serializeAws_restJson1BatchGetIdentityProviderExclusivityInputListItem(entry, context);
    });
};
var serializeAws_restJson1BatchGetIdentityProviderExclusivityInputListItem = function (input, context) {
    return __assign({}, (input.providerName != null && { "providerName": input.providerName }));
};
var serializeAws_restJson1BatchGetLoginAssociationInputList = function (input, context) {
    return input.filter(function (e) { return e != null; }).map(function (entry) {
        return serializeAws_restJson1BatchGetLoginAssociationInputListItem(entry, context);
    });
};
var serializeAws_restJson1BatchGetLoginAssociationInputListItem = function (input, context) {
    return __assign(__assign({}, (input.identityProvider != null && { "identityProvider": input.identityProvider })), (input.loginId != null && { "loginId": input.loginId }));
};
var serializeAws_restJson1BatchPutLoginAssociationInputList = function (input, context) {
    return input.filter(function (e) { return e != null; }).map(function (entry) {
        return serializeAws_restJson1BatchPutLoginAssociationInputListItem(entry, context);
    });
};
var serializeAws_restJson1BatchPutLoginAssociationInputListItem = function (input, context) {
    return __assign(__assign(__assign(__assign({}, (input.hatId != null && { "hatId": input.hatId })), (input.identityProvider != null && { "identityProvider": input.identityProvider })), (input.loginId != null && { "loginId": input.loginId })), (input.vibeId != null && { "vibeId": input.vibeId }));
};
var deserializeAws_restJson1ValidationExceptionField = function (output, context) {
    return {
        message: __expectString(output.message),
        path: __expectString(output.path),
    };
};
var deserializeAws_restJson1ValidationExceptionFieldList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ValidationExceptionField(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteLoginAssociationFailedOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchDeleteLoginAssociationFailedOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteLoginAssociationFailedOutputListItem = function (output, context) {
    return {
        error: __expectString(output.error),
        errorType: __expectString(output.errorType),
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
    };
};
var deserializeAws_restJson1BatchDeleteLoginAssociationOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchDeleteLoginAssociationOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteLoginAssociationOutputListItem = function (output, context) {
    return {
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
    };
};
var deserializeAws_restJson1BatchFindLoginAssociationOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchFindLoginAssociationOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchFindLoginAssociationOutputListItem = function (output, context) {
    return {
        exclusivity: __expectString(output.exclusivity),
        hatId: __expectString(output.hatId),
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
        vibeId: __expectString(output.vibeId),
    };
};
var deserializeAws_restJson1BatchFindLoginAssociationOutputMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = deserializeAws_restJson1BatchFindLoginAssociationOutputList(value, context), _b));
    }, {});
};
var deserializeAws_restJson1BatchGetIdentityProviderExclusivityNotFoundOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchGetIdentityProviderExclusivityNotFoundOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetIdentityProviderExclusivityNotFoundOutputListItem = function (output, context) {
    return {
        providerName: __expectString(output.providerName),
    };
};
var deserializeAws_restJson1BatchGetIdentityProviderExclusivityOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchGetIdentityProviderExclusivityOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetIdentityProviderExclusivityOutputListItem = function (output, context) {
    return {
        exclusivity: __expectString(output.exclusivity),
        providerName: __expectString(output.providerName),
    };
};
var deserializeAws_restJson1BatchGetLoginAssociationFailedOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchGetLoginAssociationFailedOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetLoginAssociationFailedOutputListItem = function (output, context) {
    return {
        error: __expectString(output.error),
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
    };
};
var deserializeAws_restJson1BatchGetLoginAssociationOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchGetLoginAssociationOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetLoginAssociationOutputListItem = function (output, context) {
    return {
        exclusivity: __expectString(output.exclusivity),
        hatId: __expectString(output.hatId),
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
        vibeId: __expectString(output.vibeId),
    };
};
var deserializeAws_restJson1BatchPutLoginAssociationFailedOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchPutLoginAssociationFailedOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchPutLoginAssociationFailedOutputListItem = function (output, context) {
    return {
        error: __expectString(output.error),
        errorType: __expectString(output.errorType),
        exclusivity: __expectString(output.exclusivity),
        hatId: __expectString(output.hatId),
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
        vibeId: __expectString(output.vibeId),
    };
};
var deserializeAws_restJson1BatchPutLoginAssociationOutputList = function (output, context) {
    var retVal = (output || []).filter(function (e) { return e != null; }).map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1BatchPutLoginAssociationOutputListItem(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchPutLoginAssociationOutputListItem = function (output, context) {
    return {
        createdExclusiveVibe: __expectBoolean(output.createdExclusiveVibe),
        exclusivity: __expectString(output.exclusivity),
        hatId: __expectString(output.hatId),
        identityProvider: __expectString(output.identityProvider),
        loginId: __expectString(output.loginId),
        newVibeIdFromExclusionCreation: __expectString(output.newVibeIdFromExclusionCreation),
        vibeId: __expectString(output.vibeId),
    };
};
var deserializeMetadata = function (output) {
    var _a;
    return ({
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"],
    });
};
var collectBody = function (streamBody, context) {
    if (streamBody === void 0) { streamBody = new Uint8Array(); }
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function (streamBody, context) { return collectBody(streamBody, context).then(function (body) { return context.utf8Encoder(body); }); };
var isSerializableHeaderValue = function (value) {
    return value !== undefined &&
        value !== null &&
        value !== "" &&
        (!Object.getOwnPropertyNames(value).includes("length") ||
            value.length != 0) &&
        (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function (streamBody, context) { return collectBodyString(streamBody, context).then(function (encoded) {
    if (encoded.length) {
        return JSON.parse(encoded);
    }
    return {};
}); };
var loadRestJsonErrorCode = function (output, data) {
    var findKey = function (object, key) { return Object.keys(object).find(function (k) { return k.toLowerCase() === key.toLowerCase(); }); };
    var sanitizeErrorCode = function (rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") {
            cleanValue = cleanValue.toString();
        }
        if (cleanValue.indexOf(",") >= 0) {
            cleanValue = cleanValue.split(",")[0];
        }
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
};
